export const PLATFORM_CHAT_ENTITY_TYPE = {
  GLOBAL: 'GLOBAL',
  BRAND: 'BRAND',
  WORKSPACE: 'WORKSPACE',
  CAMPAIGN: 'CAMPAIGN',
  PROJECT: 'PROJECT',
  SECTION: 'SECTION',
  SUB_SECTION: 'SUB_SECTION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER',
  VERSION: 'VERSION',
  FILE: 'FILE',
  PAGE: 'PAGE'
};
